<template>
  <div class="w-full login-form">
    <form>
      <div class="mb-10 flex flex-row items-center justify-center">
        <BaseIcon class="mr-2" name="logo" width="28" height="32" />
        <div class="font-bold text-xs">Информирование граждан</div>
      </div>
      <div class="mb-2">
        <BaseLabel for-id="email">Логин</BaseLabel>
        <BaseInput
          v-model="formData.email"
          id="email"
          :hasError="hasFormError('email')"
        />
        <BaseError v-if="hasFormError('email')">
          {{ getFormError('email') }}
        </BaseError>
      </div>
      <div class="mb-8">
        <BaseLabel for-id="password">Пароль</BaseLabel>
        <BaseInput
          v-model="formData.password"
          type="password"
          id="password"
          :hasError="hasFormError('password')"
        />
        <BaseError v-if="hasFormError('password')">
          {{ getFormError('password') }}
        </BaseError>
      </div>
      <div class="mb-4">
        <BaseButton
          class="w-full"
          size="md"
          variant="blue"
          :disabled="isLoading"
          @click="signIn"
        >
          <BaseLoader v-if="isLoading" size="xs" class="mr-1" />
          Войти
        </BaseButton>
      </div>
      <div>
        <BaseLink class="w-full text-center text-sm" to="auth.register">
          Регистрация
        </BaseLink>
      </div>
    </form>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  import Client from '@/classes/Api/Client';
  import WithHttpError from '@/components/mixins/WithHttpError';

  import BaseIcon from '@/components/global/base-icon';
  import BaseLink from '@/components/global/base-link';
  import BaseLabel from '@/components/global/base-label';
  import BaseInput from '@/components/global/base-input';
  import BaseError from '@/components/global/base-error';
  import BaseButton from '@/components/global/base-button';
  import BaseLoader from '@/components/global/base-loader';

  export default {
    name: 'LoginPage',

    components: {
      BaseIcon,
      BaseLabel,
      BaseInput,
      BaseError,
      BaseButton,
      BaseLoader,
      BaseLink,
    },

    mixins: [WithHttpError],

    data() {
      return {
        formData: {
          email: null,
          password: null,
        },

        isLoading: false,
      };
    },

    computed: {
      ...mapGetters('Auth', ['hasRole']),
    },

    methods: {
      signIn() {
        if (!(!this.isLoading && (this.isLoading = true))) {
          return;
        }

        this.clearFormErrors();

        Client.signIn(this.formData.email, this.formData.password)
          .then(() => {
            this.$store.dispatch('Auth/loadProfile').then(() => {
              if (this.hasRole(['head'])) {
                this.$router.push({name: 'head'});
              } else if (this.hasRole(['operator'])) {
                this.$router.push({name: 'operator'});
              } else {
                this.$router.push({name: 'info'});
              }
            });
          })
          .catch(this.prepareHttpError)
          .finally(() => {
            this.isLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .login-form {
    width: rem(312px);
  }
</style>
